import * as s from './style'

type Props = {
    readonly title: string,
    readonly balance: number,
    readonly textButton: string,
    readonly imgButton: any,
    readonly observation: string;
}

const Balance: React.FC<Props> = ({title, balance, textButton, imgButton, observation}) => {
    return(
        <s.container>
            <h2>{title}</h2>
            <div>
                <p>
                    R$ <span>{balance},00</span>
                </p>

                <button>
                    <span>{textButton}</span>
                    {imgButton}
                </button>
            </div>

            <span>*{observation}</span>
        </s.container>
    )
}

export default Balance